import styled from '@emotion/styled';

import IconPdf from '../../ComponentLibrary/icons/icon-pdf';
import Label from '../../ComponentLibrary/input-elements/oc-label';

export const CustomizedHeader = styled.div`
  ul,
  ol {
    margin: 0;
    padding: 0;

    li {
      margin: 0;
    }
  }

  margin-bottom: 64px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Controls = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(220px, 1fr));
  gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    margin: 0;
  }

  & + & {
    margin-top: 16px;
  }
`;

export const FieldLabel = styled(Label)`
  font-weight: 700;
  margin-bottom: 0;
`;

export const GroupLabel = styled(Label)`
  font-weight: 700;
`;

export const AssemblyGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 14px;
`;

export const Placeholder = styled.div`
  padding: 16px;
  border: 1px dashed #bbb;
  background: #fafafa;
  font-size: 14px;
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 700;
`;

export const H3 = styled.h3`
  padding-bottom: 16px;
  margin-bottom: 0;
`;

export const Lead = styled.p`
  margin: 0 0 16px 0;
  font-size: 18px;
`;

export const LocationGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, 420px) 1fr;
  gap: 24px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const SummaryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 420px;

  th,
  td {
    padding: 12px 14px;
    border-bottom: 1px solid #e6e6e6;
    text-align: left;
    font-size: 16px;
  }
  th {
    width: 260px;
    font-weight: 700;
  }
  tr:nth-of-type(odd) td {
    background: #f8f8f8;
  }
`;

export const AssemblyList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 14px;
`;

export const Select = styled.select`
  margin-bottom: 8px;
`;

export const SideBar = styled.div`
  display: grid;
  gap: 16px;
  background: #e6e6e6;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 16px;
`;

export const Title = styled.span`
  font-size: 28px;
  font-weight: 700;
  text-decoration: underline;
`;

export const ResultsPanel = styled.div`
  display: grid;
  gap: 16px;
  max-width: 860px;

  /* prevent tall, stretchy rows */
  grid-auto-rows: min-content;
  align-content: start;
`;

export const SummaryInline = styled.div`
  height: fit-content;
  display: grid;
  grid-template-columns: 170px 1fr;
  row-gap: 6px;
  column-gap: 16px;
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 24px;
  strong {
    font-weight: 700;
  }
`;

export const ResultsCard = styled.div`
  background: #fff;
  border: ${({ border }) => border || '1px solid #e6e6e6'};
  border-radius: 6px;
  overflow: hidden;
`;

export const Small = styled.small`
  font-weight: 400;
  color: #666;
`;

export const Divider = styled.hr`
  border: 0;
  height: 1px;
  background: #e6e6e6;
  margin: ${({ margin }) => margin || '8px 0'};
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;
  align-items: center;
  justify-content: flex-start;
  padding-top: 16px;
  padding-bottom: 16px;
`;

export const Footnote = styled.p`
  font-size: 12px;
  line-height: 1.5;
  color: #444;
  margin: 0;
`;

export const PdfIcon = styled(IconPdf)`
  position: relative;
  right: 0.375rem;
`;

export const QuestionWrapper = styled.div`
  margin-top: 10px;
`;

export const SubQuestionWrapper = styled.div`
  margin-top: 18px;
`;

export const FlexRow = styled.div`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  display: flex;
  gap: ${({ gap }) => gap || '12px'};
  align-items: ${({ align }) => align || 'unset'};
  justify-content: ${({ justify }) => justify || 'unset'};
`;
